export const ru_messages = {
    hello: 'Привет',
    employee_positions: {
        owner: 'Владелец',
        manager: 'Менеджер',
        cook: 'Повар',
        courier: 'Курьер',
        cashier: 'Кассир'
    },
    payment_intervals: {
        daily: 'Ежедневно',
        weekly: 'Еженедельно',
        monthly: 'Ежемесячно',
    }
}
